<template>
  <div class="grid" v-if="!mobiTablet">
    <div class="grid-title">
      <h4>
        {{ $t("_HOTEL_CHAIN.CHAIN_LIST_HOTEL") }}
      </h4>
    </div>
    <div class="grid-body pt-0 pb-0 border-top-unset">
      <v-row align="center" class="p-3">
        <v-col sm="4" class="pt-0">
          <v-text-field
            v-model="keyword"
            :label="$t('_HOTEL_CHAIN.ENTER_HOTEL_NAME_OR_CODE')"
            v-on:keyup="search()"
          ></v-text-field>
        </v-col>
        <v-col sm="5" class="pt-0">
          <v-radio-group v-model="status" row class="" @change="search()">
            <v-radio
              :label="$t('ALL')"
              value="all"
            ></v-radio>
            <v-radio
              :label="$t('ACTIVE')"
              value="1"
            ></v-radio>
            <v-radio
              :label="$t('DEACTIVE')"
              value="0"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <v-simple-table>
        <thead>
          <tr>
            <th v-for="header in headers" :class="header.class">
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="dataTable.length > 0 && !isLoading">
            <tr v-for="(item, i) in dataTable">
              <td class="text-center vertical-middle">
                {{ paging.offset + i + 1 }}
              </td>
              <td class="vertical-middle font-weight-bold">
                <a class="app-link" href="javascript:;" @click="useHotel(item)">
                  {{ item.hotelI18n.find(x => x.lang == defaultI18n).name }}
                </a>
              </td>
              <td class="text-center vertical-middle">
                {{ item.hotelCode }}
              </td>
              <td class="vertical-middle">
                {{ item.hotelI18n.find(x => x.lang == defaultI18n).address }}
              </td>
              <td class="text-center vertical-middle">
                <div style="color:green" v-if="item.active">
                  {{ $t("ACTIVE") }}
                </div>
                <div style="color:red" v-if="!item.active">
                  {{ $t("DEACTIVE") }}
                </div>
              </td>
              <td class="text-center vertical-middle">
                <a class="delete app-link" @click="useHotel(item)" style="color:#173d8f!important" v-if="!item.isLoading">
                  {{
                    $t("USE_HOTEL")
                  }}
                  <v-icon left size="15" color="#173d8f">open_in_new</v-icon>
                </a>
                <a class="delete app-link" style="color:#173d8f!important;" v-else>
                  {{
                    $t("IS_REDIRECTING")
                  }}
                  <v-progress-circular class="ml-2"
                    indeterminate
                    color="primary"
                    :width="3"
                    :size="16"
                  ></v-progress-circular>
                </a>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan="7"
                class="text-center vertical-middle font-weight-bold font-italic"
                style="color:red"
              >
                {{ $t("NO_DATA") }}
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>

      <paging
        v-if="paging.total"
        :paging.sync="paging"
        @changePage="changePage"
      >
        <span slot="totalItems" v-if="paging"
          >{{ $t("TOTAL") }}: {{ $tc("HOTEL",  paging.total) }}</span
        >
      </paging>
    </div>
  </div>
  <div class="grid" v-else>
    <div class="pt-0 pb-0 border-top-unset">
      <v-row align="center" class="m-0 d-sticky-search">
        <v-col sm="12" class="col-search" >
          <v-text-field
            v-model="keyword"
            :label="$t('_HOTEL_CHAIN.ENTER_HOTEL_NAME_OR_CODE')"
            @input="searchHotel(true)"
            prepend-icon="search"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
     <div v-if="hotelList.length > 0 && !isLoading" id="list-hotel-scroll">
        <v-subheader >{{ $t("TOTAL") }}: {{ $tc("HOTEL",  paging.total) }}</v-subheader>
        <v-list dense class="p-0">
          <v-list-item-group
            v-model="selectedItem"
            color="primary"
          >
            <v-list-item
              v-for="(item, i) in hotelList"
              :key="i"
              class="border-top"
              :disabled="!item.active"
              @click="useHotel(item)"
            >
              <v-list-item-icon>
                <v-icon v-text="selectHotel.id === item.id ? 'done' : ''"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                  <div class="d-flex fs-10 align-items-center justify-content-between">
                    <div>{{item.hotelI18n.find(x => x.lang == defaultI18n).name}}</div>
                    <div class="ml-2">{{ item.hotelCode }}</div>
                  </div>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
     </div>
    <template v-else-if="!isLoading">
       <div class="d-flex justify-content-center align-items-center" style="height: 70vh">
          <div class="text-center">
            <img src="@/assets/not_found.png"/>
            <p class="mt-3"> {{ $t('NO_DATA') }}</p>
          </div>
        </div>
    </template>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { _alert } from "@/_helpers/function.js";
import { optionUTC } from "@/_helpers/globalData.js";

export default {
  components: {
    paging: Paging
  },
  data() {
    return {
      optionUTC: optionUTC(),
      isLoading: false,
      dialog: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("HOTEL_NAME"),
          class: "left w-20"
        },
        {
          text: this.$t("HOTEL_CODE"),
          class: "text-center w-20"
        },
        {
          text: this.$t("ADDRESS"),
          class: "w-20"
        },
        {
          text: this.$t("STATUS"),
          class: "text-center w-20"
        },
        {
          text: this.$t("ACTION"),
          class: "text-center"
        }
      ],
      data: [],
      dataTable: [],
      keyword: "",
      status: "all",
      listStatus: [],
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      selectedItem: null,
      selectHotel: null,
      hotelList: [],
      index: 0,
      loadingView: true,
      end: true,
    };
  },

  created() {
    this.listStatus = [
      { id: "all", value: this.$t("ALL") },
      { id: 1, value: this.$t("ACTIVE") },
      { id: 0, value: this.$t("DEACTIVE") },
    ];
    this.initialize();
  },
  mounted() {},
  watch: {},
  methods: {
    initialize() {
      if (this.mobiTablet) {
        this.searchHotel();
      } else {
        this.search();
      }
    },
    search() {
      clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
      let body = {};
      body.keyword = this.keyword;
      if (this.status === "all") {
        body.status = null;
      } else {
        body.status = this.status;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      this.isLoading = true;
      chainService
        .get(body)
        .then(res => {
          this.data = res.data;
          this.dataTable = res.data.map(e => Object.assign(e, {isLoading: false}));
          if (!this.selectedItem && this.mobiTablet){
            this.selectedItem = 0;
            this.selectHotel = this.dataTable[0];
            this.useHotel(this.dataTable[0]);
          }
          this.paging.total = res.total;
        })
        .finally(() => (this.isLoading = false));
      }, 500);
    },
    searchHotel(val) {
      clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
        let body = {};
        body.keyword = this.keyword;
        body.status = null;
        body.limit = 20;
        body.offset = this.index * 20;
        if (this.index === 0 || val) {
          this.index = 0;
          this.hotelList.splice(0, this.hotelList.length);
        }
        this.loadingView = true;
        this.end = true;
        chainService
          .get(body)
          .then(res => {
            res.data.forEach(element => {
              this.hotelList.push(element);
            });
            this.hotelList =  Array.from(new Set(this.hotelList));
            if (res.data.length < 20) {
              this.end = true;
            } else {
              this.end = false;
            }
            if (!this.selectHotel){
              this.selectedItem = 0;
              this.selectHotel = this.hotelList[0];
              this.useHotel(this.hotelList[0]);
            }
            if (this.index === 0) {
              document.body.scrollTop = 0; // For Safari
              document.documentElement.scrollTop = 0;
              window.addEventListener('scroll', this.lazyLoad);
            }
            setTimeout(() => {
              this.loadingView = false;
            }, 300);
            this.paging.total = res.total;
          })
          .finally(() => (this.loadingView = false));
			}, 500);
      
    },
    viewMore() {
			this.loadingView = true;
			if (this.end === false) {
				this.index++;
			}
			this.searchHotel();
		},
    lazyLoad() {
			const list = document.getElementById('list-hotel-scroll');
			if (list && list.offsetHeight && 
				window.pageYOffset >= list.offsetHeight - 800 &&
				this.loadingView === false &&
				this.end === false
			) {
				this.viewMore();
			}
		},
    useHotel(item) {
       this.$session.set("ojbBooking", null);
       item.isLoading = true;
       this.$forceUpdate();
      chainService.useHotel(item.id).then(res => {
        if (res.responseCode != 0) {
          loader.hide();
          return false;
        }
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("currentUser", JSON.stringify(res.data));
        localStorage.setItem("jwt", res.data.token);
        localStorage.setItem("showmenuchain", JSON.stringify(true));
        localStorage.setItem(`${res.data.hotel.id}-beLink`, res.data.hotel.beLink);
        localStorage.setItem("defaultLanguage", res.data.hotel.defaultLanguage);

        let gmt = null;
        let timeZoneStr = null;
        this.optionUTC.forEach(item => {
          item.children.forEach(child => {
            if (child.id === res.data.hotel.timeZoneStr) {
              localStorage.setItem("timeZoneStr", res.data.hotel.timeZoneStr);
              localStorage.setItem("GMT", child.label);
              gmt = child.label;
              timeZoneStr = res.data.hotel.timeZoneStr;
              return;
            }
          })
        })
        const localArrToken = localStorage.getItem("arrToken") ? JSON.parse(localStorage.getItem("arrToken")) : [];
          if (localArrToken && localArrToken.length > 0) {
              const arr = localArrToken.filter(e => e.hotel == null || e.hotel.id !== item.id);
              arr.push({
                hotel: res.data.hotel,
                token: res.data.token,
                usedCurrency: item.usedCurrency,
                gmt: gmt,
                timeZoneStr: timeZoneStr,
              });
              localStorage.setItem("arrToken", JSON.stringify(arr));
          } else {
              localArrToken.push({
                hotel: res.data.hotel,
                token: res.data.token,
                usedCurrency: item.usedCurrency,
                gmt: gmt,
                timeZoneStr: timeZoneStr,
              });
              localStorage.setItem("arrToken", JSON.stringify(localArrToken));
          }
        if (!this.mobiTablet) {
          // this.$router.push("about");
          this.$router.push({
            name: "about",
            params: { hotelIdParam: res.data.hotel.id }
          });
        } else {
          this.selectHotel = item;
          _alert(res, this.$t('HOTEL_CHANGE_SUCCESS'), false);
        }
        item.isLoading = false;
      });
    },
    
    changePage(paging) {
      this.paging = paging;
      this.search();
    }
  }
};
</script>
